export enum AnalyticEvent {
  USE_CASE = 'USE_CASE',
  ADD_TO_CART = 'ADD_TO_CART',
}
